import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {PAY} from '@web/core/urls'
import {unsubscribeMessage, subscribeMessage, changeBrowserLocation, openPopup} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {
    NavigationResult,
    NavigationTypeSelectableParam,
    PopupMessageReceiveParam,
    ReturnUrlComposerParam,
    ThunkApi,
} from '../interfaces'

const EASY_BANK_REGISTRATION_URL = `${PAY}/mydata/registration/remit/agreement`

const POPUP_KEY = 'REGISTER_EASY_BANK'
const MESSAGE_KEY = 'point_registration_bank'

/**
 * 간편결제 계좌 등록 페이지로 이동
 */
const navigateToEasyBankRegister = createAsyncThunk<
    NavigationResult,
    (NavigationTypeSelectableParam & PopupMessageReceiveParam & ReturnUrlComposerParam) | void,
    ThunkApi
>('navigateTo/easyBankRegister', async (args) => {
    const {forceLocationChange = false, bridgeUrl = ''} = args ?? {}
    const shouldChangeLocation = forceLocationChange || isMobile

    if (shouldChangeLocation) {
        const url = qs.stringifyUrl({
            url: EASY_BANK_REGISTRATION_URL,
            query: {
                finance: 'bank',
                target: 'remit',
                rurl: window.location.href,
                curl: window.location.href,
            },
        })
        changeBrowserLocation({url, type: 'PUSH'})
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    }

    const popupUrl = qs.stringifyUrl({
        url: EASY_BANK_REGISTRATION_URL,
        query: {
            finance: 'bank',
            target: 'remit',
        },
    })

    return new Promise<void | string>((resolve, reject) => {
        const resolveCallback = (result: {message: string}) => {
            if (result.message === 'success') {
                return resolve(result.message)
            }

            resolve()
        }

        // popup으로부터 유효한 메시지 받았을 때만 result로  메시지 전달
        subscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})

        // popup만 오픈
        openPopup({
            key: POPUP_KEY,
            url: popupUrl,
            popupQuery: {
                rurl: `${bridgeUrl}/${MESSAGE_KEY}/success`,
                curl: `${bridgeUrl}/${MESSAGE_KEY}/fail`,
            },
            title: '계좌등록',
            size: {
                width: 500,
                height: 640,
            },
        })
            .then(() => resolve())
            .catch(reject)
            .finally(() => {
                // popup open 실패했든 종료했든 popup open시도가 끝났다면 message subscription 종료
                unsubscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})
            })
    })
})

export default navigateToEasyBankRegister
